import { Site, Customer } from './entities';

export enum Roles {
	LEVIANT_ADMIN = 'Leviant Admin',
	ACCOUNT_ADMIN = 'Account Admin',
	SITE_ADMIN = 'Site Admin',
	SITE_SUPERVISOR = 'Site Supervisor',
	OPERATOR = 'Operator',
}

export enum UserStatus {
	ACTIVE = 'ACTIVE',
	INVITED = 'INVITED',
	INACTIVE = 'INACTIVE',
}

export interface AuthUser {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	customerId?: string;
	pin: string | null;
	role: Roles;
	sites: Site[];
	customer?: Customer | null;
	spoofedById?: string;
}
